import { render, staticRenderFns } from "./HealthVtlApp.vue?vue&type=template&id=00245fab&"
import script from "./HealthVtlApp.vue?vue&type=script&lang=js&"
export * from "./HealthVtlApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports